import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { toWxMiniProgram } from '../../api/createHttpRequest';
import { Switch, Toast, Button, Dialog } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';
import styles from './index.module.scss';
import hand_book_bg from '../../static/images_cso/hand_book_bg.png';
import scale_icon from '../../static/images_cso/scale_icon.png';
import right_icon from '../../static/images_cso/right_icon.png';
import utils from '../../utils/utils';

const api = new ApiCore();

const HandBook = (props: any) => {

    const [list, setList] = useState<any>([]);

    useEffect(() => {
        localStorage.setItem('scaleTheme', 'darkgreen') // 设置主题颜色
        localStorage.setItem('source', 'doctor') // 设置量表路由匹配
        getInfo();
        return () => {
        }
    }, [])

    const getInfo = () => {
        let params = {
            tenantCode: process.env.REACT_APP_ENV == 'production' ? 'TENANT-029' : 'TENANT-024' // // 'TENANT-024' TENANT-014
        }
        api.getHandBookList(params).then((res: any) => {
            if (res.code == 0) {
                const _list = res.data || [];
                setList(_list);
            }
        });
    }

    const toActiveItem = async (item: any) => {
        let cso_doctor_info = sessionStorage.getItem('cso_doctor_info');
        let doctorInfo: any = {};
        if (props.doctorInfo && Object.values(props.doctorInfo).length > 0) {
            doctorInfo = props.doctorInfo;
        } else if (cso_doctor_info) {
            doctorInfo = JSON.parse(cso_doctor_info);
        }
        let auditState = doctorInfo.state;
        let isGuest = false;
        let token = sessionStorage.getItem('token');
        if (token) {
            let tokens = JSON.parse(token);
            if (tokens.isGuest) {
                isGuest = true;
            }
        }
        if (isGuest) {
            // 游客
            const result = await Dialog.confirm({
                content: '您尚未授权登录，请前往授权登录后使用',
            })
            if (result) {
                // 确定
                toWxMiniProgram('/pages/index/index?needLogin=1');
            }
        } else if (!isGuest &&(auditState !== 1 && auditState !== 4)) {
            const result = await Dialog.confirm({
                content: '您尚有个人信息未完善，请先补全个人信息后使用',
            })
            if (result) {
                // 确定
                toWxMiniProgram('/pages/csoComplete/csoComplete');
            } else {
                // 取消
            }
        } else if (item.link) {
            window.location.href = item.link;
        }
    }

    return (
        <div className={styles.hand_book_index_content} >
            <div className={styles.hand_book_index_content_head}>
                <img src={hand_book_bg} alt="" />
            </div>
            <div className={styles.hand_book_index_content_body}>
                {
                    list && list.map((val: any, key: number) => (
                        <div key={key} className={styles.list_item} onClick={() => { toActiveItem(val) }}>
                            <div className={styles.list_item_left} >
                                <img src={scale_icon} alt="" />
                            </div>
                            <div className={styles.list_item_middle} >
                                <div className={styles.text_up} >{val.title}</div>
                                <div className={styles.text_bottom} >{val.remark}</div>
                            </div>
                            <div className={styles.list_item_right} >
                                <img src={right_icon} alt="" />
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default withRouter(HandBook);